module.exports = __webpack_public_path__ + "img/报修.3a99fe8f.png";